module.exports = __webpack_public_path__ + "img/drawer_rebate.cb66a59f.svg";